import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FiX, FiZap } from 'react-icons/fi';

export default function SignInPrompt({ isOpen, onClose }) {
  const navigate = useNavigate();

  if (!isOpen) return null;

  return (
    <div style={styles.overlay} onClick={onClose}>
      <div style={styles.modal} onClick={e => e.stopPropagation()}>
        <button onClick={onClose} style={styles.closeBtn}><FiX size={20} /></button>

        <div style={styles.iconCircle}>
          <FiZap size={36} color="var(--accent)" />
        </div>

        <h2 style={styles.title}>Sign in to use ReplyCraft</h2>
        <p style={styles.subtitle}>Create a free account and get <strong>1,000 credits</strong> to start generating AI-powered replies instantly.</p>

        <div style={styles.actions}>
          <button onClick={() => navigate('/signup')} style={styles.signupBtn}>Sign Up Free</button>
          <button onClick={() => navigate('/login')} style={styles.loginBtn}>Already have an account? Log in</button>
        </div>

        <p style={styles.note}>No credit card required. 1,000 free credits on signup.</p>
      </div>
    </div>
  );
}

const styles = {
  overlay: { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.7)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: 20 },
  modal: { background: 'var(--bg-secondary)', border: '1px solid var(--border)', borderRadius: 20, padding: '40px 32px', width: '100%', maxWidth: 420, textAlign: 'center', position: 'relative' },
  closeBtn: { position: 'absolute', top: 16, right: 16, background: 'none', border: 'none', color: 'var(--text-muted)', cursor: 'pointer', padding: 4 },
  iconCircle: { width: 72, height: 72, borderRadius: '50%', background: 'var(--accent-dim)', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 20px' },
  title: { fontSize: 22, fontWeight: 700, color: 'var(--text-primary)', marginBottom: 10 },
  subtitle: { fontSize: 15, color: 'var(--text-secondary)', lineHeight: 1.6, marginBottom: 28 },
  actions: { display: 'flex', flexDirection: 'column', gap: 10 },
  signupBtn: { padding: '14px', background: 'var(--accent)', color: 'white', border: 'none', borderRadius: 10, fontSize: 16, fontWeight: 600, cursor: 'pointer' },
  loginBtn: { padding: '12px', background: 'none', border: '1px solid var(--border)', borderRadius: 10, color: 'var(--text-secondary)', fontSize: 14, cursor: 'pointer' },
  note: { fontSize: 12, color: 'var(--text-muted)', marginTop: 20 }
};
